<template>
  <div class="tooltip" :style="{top: props.top, lineHeight: props.line}" v-html="props.title"></div>
</template>

<script setup>
const props = defineProps(['title', 'top', 'line'])
</script>

<style scoped>

.tooltip {
  position: absolute;
  left: 50%;
  width: max-content;
  max-width: min(280px, calc(100vw - 24px));
  height: auto;
  text-align: center;
  line-height: 38px;
  background-color: rgba(0, 0, 0, .8);
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  white-space: normal;
  word-break: break-word;
  transform: translateX(-50%);
  z-index: 99;
  overflow: hidden;
  padding: 0 10px;
  text-transform: none;
  box-shadow: 0 1px 5px rgba(0, 0, 0, .1);
  opacity: 0;
  visibility: hidden;
  transition: all .3s ease-in;
}

.box:hover > .tooltip,
.tip:hover .tooltip {
  opacity: 1;
  visibility: visible;
}
</style>